import React from "react"

import { makeStyles } from "@material-ui/core/styles"

interface Props {
  size?: number | string
  width?: number | string
  height?: number | string
}

export const useStyles = makeStyles({
  logo: (props: Props) => ({
    maxWidth: "100%",
    width: props.width || props.size || "100%",
    height: "auto",
    objectFit: "contain",
    maxHeight: props.height || props.size || "100%",
  }),
})

const Logo: React.FC<Props> = (props: Props) => {
  const classes = useStyles(props)
  return (
    <img
      src={process.env.GATSBY_LOGO_PATH || "/bradbury-logo.svg"}
      alt="Bradbury Access Your Money"
      className={classes.logo}
    />
  )
}

export default Logo
